module.exports = {
  __depends__: [
    require('../draw'),
    require('../import')
  ]
};


// WEBPACK FOOTER //
// ./~/bpmn-js/lib/core/index.js